import styles from './CouponItem.module.css'
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {useEffect, useRef, useState} from "react";
import TableItem from "../../FormTemplate/TableItem/TableItem";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
interface ICouponData
{
    cpCount:number
    type:number
    validTo:Date
    discount:number
    count:number
    desc:string
    valid:boolean
    pref:string
    domain:string
}
export default function CouponItem()
{
    const [val,setVal] = useState<string[]>(["0","0", dateToExcel(new Date()),"0","Свободный","","","all;"])
    const stateRef = useRef<ErrorLineItemRef>(null)
    const [crCoupon, setrCoupon] = useState<any>()
    const [couponState, setCouponState] = useState<ICouponData>({
        count: 0,
        discount: 0,
        cpCount: 0,
        validTo: new Date(),
        type: -1,
        desc: "Свободный",
        valid: false,
        pref:"",
        domain:"all;"
    })

    const loggerRef = useRef<ILoggerItem>(null)

    const couponListData = useRef(null)
    const [ldrCouponList,rsCouponList,exCouponList] = useApiQuery("/ref/coupon/list","get",couponListData);
    const [couponList, setCouponList] = useState<{
        [key:string]:any
    }[]>([])


    const makeCouponData = useRef<{
        mainCount: number
        type:number
        discount:number
        desc:string
        validTo?:Date
        count?:number
        pref?:string
        domain?:string
    }>()
    const [ldrMakeCoupon,rsMakeCoupon,exMakeCoupon] = useApiQuery("/tarif/coupon/gen","post",makeCouponData);

    const dataCouponDelete = useRef<{
        couponId:string
    }>()
    const [ldrCouponDelete,rsCouponDelete,exCouponDelete] = useApiQuery("/tarif/coupon/delete","post",dataCouponDelete);



    const couponTypeListData = useRef(null)
    const [ldrCouponTypeList,rsCouponTypeList,exCouponTypeList] = useApiQuery("/ref/coupon/type/list","get",couponTypeListData);
    const [couponTypeList, setCouponTypeList] = useState<{
        [key:string]:any
    }[]>([])

    const [unitTypeList, setUnitTypeList] = useState<SelectUnitDataInt[]>([])


    useEffect(()=>{
        loadCouponList()
    },[couponListData])

    useEffect(()=>{
        loadCouponTypeList()

    },[couponTypeListData])

    useEffect(()=>{console.log(couponState)},[couponState])


    useEffect(()=>{
        if(couponTypeList?.length)
        {
            const x:SelectUnitDataInt[] = couponTypeList?.map((item)=>{
                return {
                    val: item?.type,
                    name: item?.name
                }
            })
            setUnitTypeList(x)
        }
    },[couponTypeList])

    function dateToExcel(dt:Date) {
        const x = dt.toISOString()
        return x.substring(8,10) + "." + x.substring(5,7) + "." + x.substring(0,4)
    }

    function ExcelToDate(x:string) {
        const dt =  x.substring(6,10) + "-" + x.substring(3,5) + "-" + x.substring(0,2)
        return new Date(dt)
    }

    const loadCouponTypeList = () =>{
        exCouponTypeList().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                setCouponTypeList(e?.payload)
            }
        })
    }

    const loadCouponList = () =>{
        exCouponList().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                const x = e?.payload?.map((item:any)=>{
                    let validTo = "9999-12-31"
                    let count = 0

                    switch (item?.type)
                    {
                        case 1:
                            validTo = item?.validTo
                            break
                        case 2:
                            count = item?.count
                            break
                        default:
                            break
                    }

                    return {...item,
                        typeText: item?.couponTypeOne ? item?.couponTypeOne?.name : "Не известный",
                        validTo: validTo,
                        count: count
                    }
                })
                setCouponList(x)
            }
        })


    }

    const handleDelete = ()=>{
        if(!crCoupon) return
        const quest = window.confirm("Вы уверены что хотите удалить купон?")
        if(! quest) return
        dataCouponDelete.current = {couponId: crCoupon?.couponId}
        exCouponDelete().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show(`Купон ${crCoupon?.couponId} удален`, false,0)
                loadCouponList()
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000)

        })
    }

    const  handleGen = () =>{
        if(!stateRef.current)return
        if(couponState?.type < 0)
        {
            stateRef.current.show("Не выбран тип купона",true,5000)
            return
        }
        if(couponState?.cpCount <= 0)
        {
            stateRef.current.show("Количество купонов для генерации меньше или равно 0",true,5000)
            return
        }
        if(couponState?.discount <= 0)
        {
            stateRef.current.show("Размер скидки меньше или равен 0",true,5000)
            return
        }
        switch (couponState.type)
        {
            case 1:
                if(couponState.validTo < new Date())
                {
                    stateRef.current.show("Дата окончания купона уже прошла",true,5000)
                    return
                }
                break
            case 2:
                if(couponState.count <=0)
                {
                    stateRef.current.show("Количество использований купона меньше или равно 0",true,5000)
                    return
                }
                break
        }
        makeCouponData.current = {
            validTo:couponState?.validTo,
            count: couponState?.count,
            desc: couponState?.desc,
            discount: couponState?.discount,
            mainCount: couponState?.cpCount,
            type: couponState?.type,
            pref: couponState?.pref,
            domain: couponState?.domain,


        }
        console.log(makeCouponData)
        if(loggerRef.current)loggerRef.current.clear()
        exMakeCoupon().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                if(loggerRef.current)loggerRef.current.log(e?.payload)
                if(stateRef.current)stateRef.current.show("Задача выполнена", false,5000)
                loadCouponList()
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,5000)

        })



    }



    return(
        <div className={styles.mainCont}>
            <MainFormTemplate maxWidth={"1200px"} title={"Генерация купонов"}>
                <div className={"row"}>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrTitle}>Прогресс работы</div>
                        <div className={styles.ldr}>
                            <WaitLoader loading={ldrCouponList || ldrCouponTypeList || ldrMakeCoupon} api={rsCouponTypeList} onlyLoading={true}>

                            </WaitLoader>
                        </div>

                    </div>
                </div>
                <div className={"row mb-2  align-items-center"}>
                    <div className={"col-md-4"}>
                        <div className={styles.emCont}>
                            <SelectUnit inData={unitTypeList} capt={"Тип купона"} getVal={(e)=> {
                                if(e?.length)
                                {
                                    setCouponState({...couponState,type: Number(e[0])})
                                    return
                                }
                                setCouponState({...couponState, valid: false})

                            } } />
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={styles.emCont}>
                            <InputItem
                                val={val[0]}
                                mode={"ei"}
                                title={"Сколько"}
                                placeHolder={"Штук"}
                                regExp={/^[0-9]{1,2}$/ui}
                                onChange={(e)=>{
                                    val[0]=e
                                    setVal(val)
                                    if(e?.match(/^[0-9]{1,2}$/ui))
                                    {
                                        setCouponState({...couponState,cpCount: Number(e)})
                                        return
                                    }
                                    setCouponState({...couponState, valid: false})
                                }}
                                titleShift={1}
                                info={"Количество купонов"}

                            />
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={styles.emCont}>
                            <InputItem
                                val={val[1]}
                                mode={"ei"}
                                title={"Скидка"}
                                placeHolder={"Скидка"}
                                regExp={/^[0-9]{1,5}$/ui}
                                onChange={(e)=>{
                                    val[1] = e
                                    setVal(val)
                                    if(e?.match(/^[0-9]{1,5}$/ui))
                                    {
                                        setCouponState({...couponState,discount: Number(e)})
                                        return
                                    }
                                    setCouponState({...couponState, valid: false})
                                }}
                                titleShift={1}
                                info={"Скидка в рублях"}

                            />
                        </div>
                    </div>





                </div>


                <div className={"row mb-2  align-items-center"}>
                    <div className={"col-md-6"}>
                        <div className={styles.emCont}>
                            <InputItem
                                val={val[4]}
                                mode={"ei"}
                                title={"Описание"}

                                placeHolder={"Описание"}
                                onChange={(e)=>{
                                    val[4] = e
                                    setVal(val)
                                    setCouponState({...couponState,desc: e})

                                }}
                                titleShift={-2}
                                info={"Описание пула купонов"}

                            />
                        </div>
                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.emCont}>
                            <InputItem
                                val={val[6]}
                                mode={"ei"}
                                title={"Префикс"}


                                placeHolder={"Префикс"}
                                onChange={(e)=>{
                                    val[6] = e
                                    setVal(val)
                                    setCouponState({...couponState,pref: e})

                                }}
                                titleShift={0}
                                info={"Префикс купонов"}

                            />
                        </div>
                    </div>
                    <div className={"col-md-3"}>
                        <div className={styles.emCont}>
                            <InputItem
                                val={val[7]}
                                mode={"ei"}
                                title={"Домен"}


                                placeHolder={"Домен"}
                                onChange={(e)=>{
                                    val[7] = e
                                    setVal(val)
                                    setCouponState({...couponState,domain: e})

                                }}
                                titleShift={0}
                                info={"Домен [all;]"}

                            />
                        </div>
                    </div>
                    {couponState.type === 1 &&
                        <div className={"col-md-3"}>
                            <div className={styles.emCont}>
                                <InputItem
                                    val={val[2]}
                                    mode={"ei"}
                                    title={"Срок до"}
                                    placeHolder={"Срок до"}
                                    regExp={/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui}
                                    onChange={(e)=>{
                                        val[2] = e
                                        setVal(val)
                                        if(e?.match(/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui))
                                        {
                                            setCouponState({...couponState,validTo: ExcelToDate(e)})
                                            return
                                        }
                                        setCouponState({...couponState, valid: false})

                                    }}
                                    titleShift={1}
                                    info={"Срок действия до"}

                                />
                            </div>
                        </div>
                    }
                    {couponState.type === 2 &&
                        <div className={"col-md-3"}>
                            <div className={styles.emCont}>
                                <InputItem
                                    val={val[3]}
                                    mode={"ei"}
                                    title={"Количество"}
                                    placeHolder={"Количество"}
                                    regExp={/^[0-9]{1,5}$/ui}
                                    onChange={(e)=>{
                                        val[3] = e
                                        setVal(val)
                                        if(e?.match(/^[0-9]{1,5}$/ui))
                                        {
                                            setCouponState({...couponState,count: Number(e)})
                                            return
                                        }
                                        setCouponState({...couponState, valid: false})

                                    }}
                                    titleShift={1}
                                    info={"Количество использований купона"}

                                />
                            </div>



                        </div>


                    }




                </div>

                <div className={"row mb-2  align-items-center"}>
                    <div className={"col-md-6"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={handleGen}
                            >Сгенерировать</button>

                            <button type="button" className="btn btn-secondary "
                                    disabled={!crCoupon}
                                    onClick={handleDelete}
                            >{`Удалить [ ${crCoupon ? crCoupon?.couponId : ""} ]`}</button>

                        </div>

                    </div>
                </div>


                <div className={"row"}>
                    <ErrorLineItem ref={stateRef}></ErrorLineItem>
                </div>

                <div className={"row"}>
                    <div className={"col-sm-12 d-flex align-self-center"}>
                        <LoggerItem lineCount={10} ref={loggerRef} title={"Лог"}></LoggerItem>
                    </div>

                </div>

            </MainFormTemplate>
            <TableItem
                data={couponList}
                onPageCount={30}
                onReload={loadCouponList}
                exportExcel={true}
                onRecord={(e)=>setrCoupon(e)}
                column={[
                    {
                      title: "Купон",
                      fieldId: "couponId",
                      type: 0,
                      mode: "sf"
                    },
                    {
                        title: "Тип",
                        fieldId: "typeText",
                        type: 0,
                        mode: "sf"
                    },
                    {
                        title: "Домен",
                        fieldId: "domain",
                        type: 0,
                        mode: "sf"
                    },
                    {
                        title: "Скидка (руб.)",
                        fieldId: "discount",
                        type: 1,
                        mode: "s"
                    },
                    {
                        title: "Дата до",
                        fieldId: "validTo",
                        type: 2,
                        mode: "s"
                    },
                    {
                        title: "Остаток",
                        fieldId: "count",
                        type: 1,
                        mode: "s"
                    },
                    {
                        title: "Описание",
                        fieldId: "desc",
                        type: 0,
                        mode: "fs",
                        maxLen: 40
                    },
                ]}



            />
        </div>
    )


}